{
  "cancel": "Abbrechen",
  "delete": "Löschen",
  "close": "Schließen",
  "done": "Fertig",
  "deleteTitle": "Datensatz löschen?",
  "deleteText": "Soll der Datensatz unwiderruflich gelöscht werden?",
  "info": "Info",
  "objectInfoTitle": "Datensatzinformation",
  "createdBy": "Erstellt von",
  "createdAt": "Erstellt am",
  "lastEditedBy": "Zuletzt bearbeitet von",
  "editedAt": "Bearbeitet am",
  "unknown": "Unbekannt",
  "system": "System",
  "objectHistoryTitle": "Datensatz & Historie",
  "changes": "Änderungen",
  "loadingHistory": "Lade Historie…",
  "noHistory": "Noch keine Änderungs-Historie vorhanden.",
  "historyLoadError": "Historie konnte nicht geladen werden.",
  "someone": "Jemand",
  "historyDate": "Datum",
  "historyUser": "Benutzer",
  "historyChange": "Änderung",
  "actionCreated": "angelegt",
  "actionDeleted": "gelöscht",
  "actionChanged": "geändert",
  "historyFallbackWithTitle": "„{{title}}“ {{verb}}",
  "historyFallback": "Eintrag {{verb}}",
  "updateAvailable": "Update verfügbar",
  "updateBody": "Es steht eine neue Version dieser App zur Verfügung.\nZum Erhalt best möglicher Funktion ist eine Aktualisierung erforderlich.",
  "updateLater": "Später aktualisieren",
  "updateNow": "Aktualisieren",
  "internetRequired": "(Internet notwendig)",
  "releaseInfo": "Updateinformation",
  "selectMandant": "Mandant auswählen",
  "noLicence": "Keine Lizenz vorhanden",
  "noCompanyAssigned": "Du bist keinem Unternehmen zugeordnet.",
  "companiesLoadError": "Es können keine Unternehmen geladen werden",
  "logout": "Abmelden"
}
